import React, { useState } from "react";
import styles from "./PlaydateInviteRecipientView.module.css";
import PlaydateInviteBaseView from "./PlaydateInviteBaseView";
import TextAreaInput from "../../input/TextAreaInput";
import ActionButton from "../../button/ActionButton";
import UnderlineButton from "../../button/UnderlineButton";

type PlaydateInviteRecipientAcceptViewProps = {
    message?: string;
    onBack: () => void;
    onBackToDetails: () => void;
    onSubmitConfirm: (message: string) => void;
    baseZIndex?: number;
    loading?: boolean;
};

const PlaydateInviteRecipientAcceptView: React.FC<PlaydateInviteRecipientAcceptViewProps> = ({
    message,
    onBack,
    onBackToDetails,
    onSubmitConfirm,
    baseZIndex,
    loading,
}) => {
    const [confirmMessage, setConfirmMessage] = useState<string>(message ?? "");

    return (
        <PlaydateInviteBaseView
            baseZIndex={baseZIndex}
            onBack={onBack}
            title="Response Details"
            infoText="Glad you can make it! Please let the host know you’re joining."
            topIcon="happy"
            useSectionDivider={false}
        >
            <TextAreaInput
                message={confirmMessage}
                placeholder="(optional)"
                setMessage={setConfirmMessage}
                className={styles.cancellationMessageTextArea}
            />
            <div className={styles.buttonBuffer} />
            <div className={styles.buttonContainer}>
                <ActionButton
                    onClick={() => onSubmitConfirm(confirmMessage)}
                    hasLoadingSignal={loading}
                    className={styles.cancellationPrimaryButton}
                >
                    Confirm Response
                </ActionButton>
                <UnderlineButton onClick={onBackToDetails}>
                    Back to Invite Details
                </UnderlineButton>
            </div>
        </PlaydateInviteBaseView>
    );
};

export default PlaydateInviteRecipientAcceptView;
